import { render } from "./salesNotesDialog.vue?vue&type=template&id=efb29766"
import script from "./salesNotesDialog.vue?vue&type=script&lang=js"
export * from "./salesNotesDialog.vue?vue&type=script&lang=js"

import "./salesNotesDialog.vue?vue&type=style&index=0&id=efb29766&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__